import $api from "../http";

/**
 * `Н` (0.7): контакты своего профиля приходят отдельным запросом.
 *
 * После п. 30 `/refresh` отдаёт `email`/`tel` = `null`: контакты — персональные
 * данные, и продление сессии их не возвращает. Шапка и профиль берут их из
 * `GET /my/profile`, а не из ответа `/refresh`.
 */
export interface IMyProfile {
  userId: number;
  firstName: string | null;
  lastName: string | null;
  surName: string | null;
  tel: string | null;
  email: string | null;
  accountState: string;
  /** `Ф0`: срок отмены удаления (ISO) или null. */
  deletionDueAt: string | null;
}

export default class ProfileService {
  static async getProfile(): Promise<IMyProfile> {
    const response = await $api.get<IMyProfile>("/my/profile", {
      withCredentials: true,
    });

    return response.data;
  }
}
